import {
  userStatus,
  envConfig,
  EncryptMe
} from '../_helpers';

export const momentumService = {
  listMomentums,
  listFilters,
  storeMomentum,
  listAvailableChannels,
  softDeleteMomentum,
  listMomentumById,
  updateMomentum,
  updateMomentumStatus,
  listCustomFilters
}

async function listMomentums(domain) {
  let user = userStatus();

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    }
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/momentum/list/${domain}`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function listMomentumById(uuid) {
  let user = userStatus();

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    }
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/momentum/list?id=${uuid}`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function listFilters(domain) {
  let user = userStatus();

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    }
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/person/filter/${domain}`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function listCustomFilters(domain, filterBy) {
  let user = userStatus();

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    }
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/person/search/${domain}/filter/${filterBy}`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function listAvailableChannels(domain) {
  let user = userStatus();

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    }
  }

  const response = await fetch(`${envConfig.MAIN_API_URL}/domain/channels/${domain}`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function storeMomentum(data) {
  const user = userStatus();

  let encrypted = await EncryptMe(data);

  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/momentum/create`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function updateMomentum(data) {
  const user = userStatus();

  let encrypted = await EncryptMe(data);

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/momentum/update`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function updateMomentumStatus(data, requestType, isDcm, domain) {
  const user = userStatus();

  let jsonData = JSON.parse(data);

  if ( requestType ) {
    if ( requestType === 'start' ) {
      jsonData.status = "Active";
    } else {
      jsonData.status = "Paused";
    }
  }

  delete jsonData.channels;
  delete jsonData.active;
  delete jsonData.__v;
  delete jsonData._id;
  delete jsonData.created_at;
  delete jsonData.updated_at;
  delete jsonData.activation_date;
  delete jsonData.channels;

  if ( isDcm ) {
    delete jsonData.channel_uuid;
  }

  let encrypted = await EncryptMe(jsonData);

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    },
    body: JSON.stringify(encrypted)
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/momentum/update`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}

async function softDeleteMomentum(uuid, domain, data) {
  const user = userStatus();

  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${user.bearer_token}`,
      'req-language': 'pt_BR'
    }
  }

  const response = await fetch(`${envConfig.MOMENTUM_API_URL}/momentum/remove/${data}`, requestOptions);
  return response.status !== 200 ? Promise.reject(await response.json()) : await response.json();
}